(function () {
	'use strict';

	angular.module('sempraWebapp').service('getMonthsService', getMonths);

	/** @ngInject */
	function getMonths (moment) {
		this.getMonthList = function() {
			var curentLocales = moment.monthsShort();

			return curentLocales;
		};
	}
  })();
